import MUIChip, { ChipProps } from '@mui/material/Chip'

export const Chip = (props: ChipProps) => {
  return <MUIChip data-testid="chip" {...props} />
}
